import {
  AppstoreOutlined,
  HomeOutlined,
  SettingOutlined,
} from "@ant-design/icons";

export const AdminSideBar = (navigate, setselectedKey) => [
  {
    key: "/",
    icon: <HomeOutlined />,
    label: "Home",
    onClick: () => {
      setselectedKey("/");
      navigate("/");
    },
  },
  {
    key: "/plans-packages",
    icon: <AppstoreOutlined />,
    label: "Plans & Packages",
    children: [
      {
        key: "/plans-packages/child",
        label: "Plan",
        onClick: () => {
          setselectedKey("/plans-packages/child");
          navigate("/plans-packages");
        },
      },
    ],
  },
  {
    key: "/permissons",
    icon: <AppstoreOutlined />,
    label: "Permissons",
    onClick: () => {
      setselectedKey("/permissons");
      navigate("/permissons");
    },
  },
  {
    key: "/settings",
    icon: <SettingOutlined />,
    label: "Settings",
    children: [
      {
        key: "/personal",
        label: "Personal",
        onClick: () => {
          setselectedKey("/personal");
          navigate("/personal");
        },
      },
      {
        key: "/widget-cdn",
        label: "Widget CDN",
        onClick: () => {
          setselectedKey("/widget-cdn");
          navigate("/widget-cdn");
        },
      },
    ],
  },
  {
    key: "/company",
    icon: <AppstoreOutlined />,
    label: "Companies",
    onClick: () => {
      setselectedKey("/company");
      navigate("/company");
    },
  },
];
